import React from 'react';
import { Text } from '@chakra-ui/react';
import { ConfirmDialog } from 'src/components/molecules/ConfirmDialog';

type DeleteGroupDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  groupName: string;
  isLoading: boolean;
};

export const DeleteGroupDialog: React.FC<DeleteGroupDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  groupName,
  isLoading,
}) => {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      headerText="Delete Campaign Group"
      bodyText={
        <Text>
          Are you sure you want to delete <strong>{groupName}</strong>? This
          action cannot be undone.
        </Text>
      }
      confirmText="Delete"
      isLoading={isLoading}
    />
  );
};
